import { EmptyState } from "../../components/widgets/empty-state/EmptyState";

function SpsPromptsEmptyState() {
  return <EmptyState text="Add New Field" />;
}

export { SpsPromptsEmptyState };
